import { http } from 'services/http';
import type { TAuthReq, TTokenRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IAuthSmsMutationOptions {
  handleSuccess?: (data: TTokenRes) => void;
  handleError?: () => void;
}

export const useAuthMutation = (options?: IAuthSmsMutationOptions) => {
  return useMutationBase<TTokenRes, unknown, TAuthReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TTokenRes>('/v1/auth', variables, { withCredentials: false });

      return res.data;
    },
    onSuccess: options?.handleSuccess,
    onError: options?.handleError,
  });
};
